export default "__VITE_ASSET__D7TF4aKu__"